module.exports = __webpack_public_path__ + "img/yoga.718bb52f.svg";